export default __webpack_public_path__ + "static/media/events-icon-active.955a5fb2.webp";